export const undefinedFunctionWarning = (fnName) => {
    return (..._args) => console.warn(`function ${fnName} is not defined`)
}